// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ActivityOut } from './activityOut.zod.ts';
import { AttachmentOut } from './attachmentOut.zod.ts';
import { FeedbackPermissions } from './feedbackPermissions.zod.ts';
import { PersonRef } from './personRef.zod.ts';

export const FeedbackDetailOut = zod.object({
  "activity": zod.array(ActivityOut),
  "attachments": zod.array(AttachmentOut),
  "author": PersonRef,
  "category": zod.enum(['bug', 'enhancement', 'suggestion', 'question']),
  "closed_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "comment_count": zod.int(),
  "created_at": zod.iso.datetime({"offset":true}),
  "description": zod.string(),
  "id": zod.uuid(),
  "last_activity_at": zod.iso.datetime({"offset":true}),
  "permissions": FeedbackPermissions,
  "status": zod.enum(['new', 'in_review', 'planned', 'in_progress', 'resolved', 'declined', 'cancelled']),
  "title": zod.string(),
  "updated_at": zod.iso.datetime({"offset":true})
});

export type FeedbackDetailOut = zod.input<typeof FeedbackDetailOut>;
export type FeedbackDetailOutOutput = zod.output<typeof FeedbackDetailOut>;
